export default __webpack_public_path__ + "19dd8e74b06267461af42ee193af542b.png";